import {Component, computed, inject} from '@angular/core';
import {toObservable, toSignal} from '@angular/core/rxjs-interop';
import {TranslatePipe} from '@ngx-translate/core';
import {catchError, of, switchMap} from 'rxjs';
import {AppSessionStore} from '../../state/app-session.store';
import {ConversationMessagesService} from '../../services/conversation-messages.service';

@Component({
  selector: 'app-messages-unread-badge',
  imports: [TranslatePipe],
  template: `@if (count() > 0) {
    <span class="messages-unread-badge" role="status" [attr.aria-label]="'messagesWorkspace.unreadConversations' | translate:{count: count()}">{{ count() > 9 ? '9+' : count() }}</span>
  }`,
  styleUrl: './messages-unread-badge.component.scss',
})
export class MessagesUnreadBadgeComponent {
  private session = inject(AppSessionStore);
  private messages = inject(ConversationMessagesService);
  private context = computed(() => ({actor: this.session.currentUser()?.guid,
    organization: this.session.contractorGuid() ?? (this.session.currentUser()?.contractors?.length === 1 ? this.session.currentUser().contractors[0] : null)}));

  readonly count = toSignal(toObservable(this.context).pipe(switchMap(({actor, organization}) => actor && organization
    ? this.messages.getUnreadCountForUser(actor, organization).pipe(catchError(() => of(0))) : of(0))), {initialValue: 0});
}
